import Snackbar from '@/types/app/snackbar';
import { ActionContext } from 'vuex';
import { AppState } from './types';

export default {
  setSnackbar(store: ActionContext<AppState, any>, snackbar: Snackbar): void {
    store.commit('setSnackbar', snackbar);
  },
  setOverlay(store: ActionContext<AppState, any>, overlay: boolean): void {
    store.commit('setOverlay', overlay);
  }
};
